import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import {
  WhatsappConversation,
  WhatsappConversationMessage,
} from "../interfaces/WhatsappConversation";

export interface WhatsappButtonMessage {
  id: string;
  title: string;
}

export interface WhatsappListRow {
  id: string;
  title: string;
  description?: string;
}

export interface WhatsappListSection {
  title: string;
  rows: WhatsappListRow[];
}

export interface WhatsappSendAttempt {
  provider: string;
  status: string;
  statusCode?: number;
}

export interface WhatsappSendResponse {
  accepted: boolean;
  provider: string;
  providerMessageId?: string;
  fallbackUsed?: boolean;
  renderedAs?: string;
  attempts?: WhatsappSendAttempt[];
}

function getAuthorization() {
  const token = validateToken();

  if (!token) {
    throw new Error("Sessão expirada. Entre novamente para consultar os atendimentos.");
  }

  return { Authorization: token.AuthStr };
}

export async function buscarConversasWhatsapp(take = 50) {
  const response = await axios.get<WhatsappConversation[]>(
    `${Globais.DOMINIOBACK}/whatsapp/conversations`,
    { headers: getAuthorization(), params: { take } }
  );

  return response.data;
}

export async function buscarMensagensConversaWhatsapp(phone: string, take = 50) {
  const response = await axios.get<WhatsappConversationMessage[]>(
    `${Globais.DOMINIOBACK}/whatsapp/conversations/${encodeURIComponent(phone)}/messages`,
    { headers: getAuthorization(), params: { take } }
  );

  console.log("Mensagens da conversa:", response.data);

  return response.data;
}

export async function excluirMensagemWhatsapp(providerMessageId: string) {
  await axios.delete(
    `${Globais.DOMINIOBACK}/whatsapp/messages/${encodeURIComponent(providerMessageId)}`,
    { headers: getAuthorization() }
  );
}

async function enviarMensagemWhatsapp(path: string, payload: object) {
  const response = await axios.post<WhatsappSendResponse>(
    `${Globais.DOMINIOBACK}/whatsapp/messages/${path}`,
    payload,
    { headers: getAuthorization() }
  );

  return response.data;
}

export function enviarTextoWhatsapp(to: string, text: string) {
  return enviarMensagemWhatsapp("text", { to, text });
}

export function enviarBotoesWhatsapp(
  to: string,
  text: string,
  buttons: WhatsappButtonMessage[],
  footer?: string
) {
  return enviarMensagemWhatsapp("buttons", { to, text, footer, buttons });
}

export function enviarListaWhatsapp(
  to: string,
  text: string,
  buttonLabel: string,
  sections: WhatsappListSection[]
) {
  return enviarMensagemWhatsapp("list", { to, text, buttonLabel, sections });
}
